import { OwnContractModelServiceMapper } from '../OwnContractModelService/OwnContractModelServiceMapper.js';

class OwnContractModelMapper {
  static createFromResponse(response) {
    return {
      carrierId: response.carrier_id,
      id: response.id,
      logoId: response.carrier_logo_id,
      isRegistered: response.is_registered,
      carrierName: response.carrier_name,
      contractId: response.contract_id,
      services: response.services.map(OwnContractModelServiceMapper.createFromResponse)
    };
  }
}

export { OwnContractModelMapper };
//# sourceMappingURL=OwnContractModelMapper.js.map
